import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { CategoryModel, FINANCE_GROUPS } from '../finance.model';

@Component({
  selector: 'finance-category-dialog',
  standalone: false,
  template: `
    <form #form="ngForm" (ngSubmit)="save()">
      <h2 mat-dialog-title>{{ category.id ? 'Modify' : 'Create' }} Category</h2>
      <mat-dialog-content>
        <mat-form-field>
          <mat-label>Name</mat-label>
          <input matInput [(ngModel)]="category.name" name="name" required>
        </mat-form-field>
        &nbsp;&nbsp;
        <mat-form-field>
          <mat-label>Group</mat-label>
          <mat-select [(ngModel)]="category.group" name="group" required>
            <mat-option *ngFor="let g of groups" [value]="g.value">{{ g.label }}</mat-option>
          </mat-select>
        </mat-form-field>
        <section>
          <mat-checkbox [(ngModel)]="category.active" name="active">Active</mat-checkbox>
        </section>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-raised-button type="submit" [disabled]="form.invalid">Save</button>
        <button mat-raised-button type="button" mat-dialog-close>Cancel</button>
      </mat-dialog-actions>
    </form>
  `
})
export class CategoryDialogComponent {
  groups = FINANCE_GROUPS;
  category: CategoryModel;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: Partial<CategoryModel>,
    private dialogRef: MatDialogRef<CategoryDialogComponent>
  ) {
    this.category = { id: '', name: '', group: 'EXPENSE', active: true, ...data };
  }

  save(): void {
    this.dialogRef.close({ ...this.category, name: this.category.name.trim() });
  }
}
